import { render } from "./CheckboxGroup.vue?vue&type=template&id=1a0ca9ed&scoped=true&ts=true"
import script from "./CheckboxGroup.vue?vue&type=script&lang=ts"
export * from "./CheckboxGroup.vue?vue&type=script&lang=ts"

import "./CheckboxGroup.vue?vue&type=style&index=0&id=1a0ca9ed&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0ca9ed"]])

export default __exports__